import React from 'react'
import cn from 'classnames'

export default ({ children, type = 'notice' }) => <div className={cn('notice', `notice--${type}`)}>{children}</div>
